<template>
  <VCard class="pricesTable">
    <VRow no-gutters class="prices">
      <VCol cols="2" class="prices__names">
        <div class="prices__row">
          {{ $t('cost') }}
        </div>
        <div class="prices__row">
          {{ $t('response') }}
        </div>
        <div class="prices__row">
          {{ $t('sms') }}
        </div>
        <div class="prices__row">
          {{ $t('calls') }}
        </div>
        <!--        <div class="prices__row">-->
        <!--          {{ $t('responseCost') }}-->
        <!--        </div>-->
        <div class="prices__row">
          {{ $t('unlimitedVacancies') }}
        </div>
        <div class="prices__row">
          {{ $t('recordOnline') }}
        </div>
        <div class="prices__row">
          {{ $t('record') }}
        </div>
        <div class="prices__row">
          {{ $t('creditCard') }}
        </div>
        <!--        <div class="prices__row">-->
        <!--          {{ $t('bankAccount') }}-->
        <!--        </div>-->
      </VCol>
      <VCol
        v-for="(price, i) in prices"
        :key="'p' + i"
        :class="{ active: active === i }"
        cols="2"
        class="prices__item"
      >
        <div class="prices__row prices__row-tarif">
          <div
            :class="{ 'primary--text': active !== i }"
            class="text-uppercase font-weight-medium"
            @click="active = i"
          >
            {{ price.name }}
          </div>
        </div>
        <div class="prices__row">
          {{ Number.isInteger(price.price) ? `${locale === 'ru' ? '' : $t('from')} ${formatCurrency(price.price, locale === 'ru' ? 'RUB' : 'USD')}` : price.price }}
        </div>
        <div class="prices__row">
          {{ price.feedback }}
        </div>
        <div class="prices__row">
          {{ price.sms }}
        </div>
        <div class="prices__row">
          {{ price.calls }}
        </div>
        <!--        <div class="prices__row">-->
        <!--          {{ price.feedbackOverPrice }}-->
        <!--        </div>-->
        <div class="prices__row">
          <VIcon v-if="price.unlimitedVacancies" color="success">
            {{ iconCheck }}
          </VIcon>
        </div>
        <div class="prices__row">
          <VIcon v-if="price.recordVideo" color="success">
            {{ iconCheck }}
          </VIcon>
        </div>
        <div class="prices__row">
          <VIcon v-if="price.recordOfflineInterview" color="success">
            {{ iconCheck }}
          </VIcon>
        </div>
        <div class="prices__row">
          <VIcon v-if="price.payCard" color="success">
            {{ iconCheck }}
          </VIcon>
        </div>
        <!--        <div class="prices__row">-->
        <!--          <VIcon v-if="price.payCashless" color="success">-->
        <!--            {{ iconCheck }}-->
        <!--          </VIcon>-->
        <!--        </div>-->
        <!--        <div class="prices__row prices__row-action">-->
        <!--          <VBtn>-->
        <!--            {{ $t('selectTariff') }}-->
        <!--          </VBtn>-->
        <!--        </div>-->
      </VCol>
    </VRow>
    <div class="text-center mt-7 d-none prices__mobile-info">
      {{ $t('swipe') }}
    </div>
    <div class="dots mt-2 d-none">
      <div
        v-for="dot in prices.length"
        :key="'d' + dot"
        :class="{ active: active === dot - 1 }"
        class="dot"
        @click="active = dot - 1"
      />
    </div>
  </VCard>
</template>

<script>
import { mdiCheck } from '@mdi/js';
import useNumberFormatter from '@/compositions/useNumberFormatter';
import useLocale from '../../compositions/useLocale';

export default {
  name: 'PricesTable',
  setup() {
    const { formatCurrency } = useNumberFormatter();
    const { locale } = useLocale();

    return {
      formatCurrency,
      locale,
    };
  },
  data() {
    return {
      iconCheck: mdiCheck,
      active: null,
      enPrices: [
        {
          name: this.$t('tariff1'),
          price: this.$t('free'),
          feedback: `5 ${this.$t('once')}`,
          sms: '0',
          calls: '0',
          feedbackOverPrice: 1000,
          unlimitedVacancies: true,
          recordVideo: true,
          recordOfflineInterview: true,
          payCard: true,
          payCashless: true,
        },
        {
          name: this.$t('tariffStart'),
          price: 23,
          feedback: 30,
          sms: 0,
          calls: 0,
          feedbackOverPrice: 0,
          unlimitedVacancies: true,
          recordVideo: true,
          recordOfflineInterview: true,
          payCard: true,
          payCashless: true,
        },
        {
          name: this.$t('tariff2'),
          price: 80,
          feedback: 50,
          sms: 250,
          calls: 250,
          feedbackOverPrice: 0,
          unlimitedVacancies: true,
          recordVideo: true,
          recordOfflineInterview: true,
          payCard: true,
          payCashless: true,
        },
        {
          name: this.$t('tariff3'),
          price: 400,
          sms: 1000,
          calls: 1000,
          feedback: 100,
          feedbackOverPrice: 500,
          unlimitedVacancies: true,
          recordVideo: true,
          recordOfflineInterview: true,
          payCard: true,
          payCashless: true,
        },
        {
          name: this.$t('tariff4'),
          price: 800,
          feedback: 250,
          sms: 2500,
          calls: 2500,
          feedbackOverPrice: 330,
          unlimitedVacancies: true,
          recordVideo: true,
          recordOfflineInterview: true,
          payCard: true,
          payCashless: true,
        },
        // TODO Максимальный тариф, заменен на Start
        // {
        //   name: this.$t('tariff5'),
        //   price: 2000,
        //   feedback: 1000,
        //   sms: 5000,
        //   calls: 5000,
        //   feedbackOverPrice: 10000,
        //   unlimitedVacancies: true,
        //   recordVideo: true,
        //   recordOfflineInterview: true,
        //   payCard: true,
        //   payCashless: true,
        // },
      ],
      ruPrices: [
        {
          name: this.$t('tariff1'),
          price: this.$t('free'),
          feedback: `5 ${this.$t('once')}`,
          sms: '0',
          calls: '0',
          feedbackOverPrice: 1000,
          unlimitedVacancies: true,
          recordVideo: true,
          recordOfflineInterview: true,
          payCard: true,
          payCashless: true,
        },
        {
          name: this.$t('tariff2'),
          price: 1500,
          feedback: 30,
          sms: 0,
          calls: 0,
          feedbackOverPrice: 0,
          unlimitedVacancies: true,
          recordVideo: true,
          recordOfflineInterview: true,
          payCard: true,
          payCashless: true,
        },
        {
          name: this.$t('tariff3'),
          price: 25000,
          sms: 1000,
          calls: 1000,
          feedback: 100,
          feedbackOverPrice: 500,
          unlimitedVacancies: true,
          recordVideo: true,
          recordOfflineInterview: true,
          payCard: true,
          payCashless: true,
        },
        {
          name: this.$t('tariff4'),
          price: 55000,
          feedback: 250,
          sms: 2500,
          calls: 2500,
          feedbackOverPrice: 330,
          unlimitedVacancies: true,
          recordVideo: true,
          recordOfflineInterview: true,
          payCard: true,
          payCashless: true,
        },
        {
          name: this.$t('tariff5'),
          price: 150000,
          feedback: 1000,
          sms: 5000,
          calls: 5000,
          feedbackOverPrice: 10000,
          unlimitedVacancies: true,
          recordVideo: true,
          recordOfflineInterview: true,
          payCard: true,
          payCashless: true,
        },
      ],
    };
  },
  computed: {
    prices() {
      return this.locale === 'ru' ? this.ruPrices : this.enPrices;
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes price-show {
  from {
    transform: translateX(20%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes price-show-reverse {
  from {
    transform: translateX(-20%);
  }
  to {
    transform: translateX(0);
  }
}

.pricesTable {
  position: relative;
  overflow-x: auto;
  .prices-overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(#eef5ff, 0.8);
    border-radius: 10px;
    z-index: 3;

    &__block {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #ffffff;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
      border-radius: 10px;
      padding: 28px;
      width: 80%;
      max-width: 675px;
    }

    &__circle {
      width: 46px;
      height: 46px;
      border-radius: 50%;
      background: linear-gradient(84.99deg, #0161a7 4.5%, #00b9f3 110.12%);
      position: relative;

      svg {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &__text {
      width: calc(100% - 58px);
    }
  }
}

.prices {
  min-width: 55rem;
  background: #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  color: #000;
  padding-bottom: $spacer * 3;
  &__row {
    height: 64px;
    display: flex;
    align-items: center;
  }
  &__names {
    padding: 64px 0;
    .prices__row {
      padding: 0 $spacer 0 $spacer * 5;
      text-align: left;
      line-height: 1.15;
      &:nth-child(odd) {
        background: #eef5ff;
      }
    }
  }
  &__item {
    text-align: center;
    .prices__row {
      justify-content: center;
      font-weight: 500;
      &:nth-child(even):not(.prices__row-action) {
        background: #eef5ff;
      }
    }
  }
  &__mobile-info {
    font-size: 18px;
  }
}
@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .prices {
    &__names {
      .prices__row {
        padding: 0 $spacer * 4 0 $spacer * 6;
      }
    }
    &__item {
      padding-bottom: $spacer * 3;
    }
  }
}
@media #{map-get($display-breakpoints, 'md-and-up')} {
  .prices {
    box-shadow: none;
    background: none;
    padding-bottom: 0;

    &__row {
      height: 70px;
      transform: none;
      &-action {
        background: transparent;
        opacity: 0;
        z-index: -1;
        position: relative;
      }
    }
    &__names {
      padding: 70px 0;
    }
    &__item {
      display: block;
      transition: all 300ms ease;
      &.active {
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
        .prices__row {
          &:nth-child(even) {
            background: transparent;
          }
          &-action {
            opacity: 1;
            z-index: 1;
            padding: 0 $spacer * 3;
          }
        }
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .prices {
    &__row {
      font-size: 0.875rem;
      height: 60px;
    }
    &__names {
      padding: 60px 0 0;
    }
    &__row-tarif {
      font-size: 0.875rem;
      line-height: 1.3;
      padding: 0 0.5rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .pricesTable {
    .prices-overlay {
      &__block {
        width: 95%;
        padding: 15px;
      }
    }
  }
  .prices {
    min-width: 45rem;
    &__row {
      font-size: 0.75rem;
      height: 50px;
    }
    &__names {
      padding: 50px 0 0;
    }
    &__row-tarif {
      font-size: 0.75rem;
      padding: 0 0.375rem;
    }
  }
  .prices__names .prices__row {
    padding: 0 0.25rem 0 1rem;
  }
}


</style>

<i18n locale="en" lang="yaml">
  cost: Cost per month
  response: Interviews
  responseCost: The cost of responses outside the plan's limit
  unlimitedVacancies: Unlimited jobs
  recordOnline: Online interview recording
  record: In-person interview recording
  creditCard: Payment by card
  bankAccount: Payment by Bank transfer
  selectTariff: Select a plan
  swipe: Swipe to select a plan
  tariff1: Promotional
  tariffStart: Start
  tariff2: Small business
  tariff3: Standard
  tariff4: Corporate
  tariff5: Unlimited
  free: Free
  unlimited: Unlimited
  sms: Text Messages
  calls: Calls
  from: Starting from
  once: one-time
</i18n>

<i18n locale="ru" lang="yaml">
  cost: Стоимость в месяц
  response: Отклики
  responseCost: Стоимость отклика сверх лимита тарифа
  unlimitedVacancies: Неограниченное количество вакансий
  recordOnline: Запись онлайн интервью
  record: Запись очного интервью
  creditCard: Оплата банковской картой
  bankAccount: Оплата по безналу
  selectTariff: Выбрать тариф
  swipe: Свайп для выбора тарифа
  tariff1: Промо-тариф
  tariff2: Старт
  tariff3: Стандартный
  tariff4: Компания
  tariff5: Массовый набор
  free: Бесплатно
  unlimited: Неограничено
  sms: SMS
  calls: Звонки
  from: от
  once: единоразово
</i18n>
